import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="4">
              <Form.Group>
                <Form.Select
                  aria-label="group"
                  type="text"
                  title="Type"
                  className="py-2"
                  isInvalid={!!errors?.type}
                  {...register("type")}
                >
                  <option value="">Select Type</option>
                  <option value="Customers">Customers</option>
                  <option value="Vendors">Vendors</option>
                  <option value="Contractors">Contractors</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.type?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  title="First Name"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.firstName}
                  {...register("firstName")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.firstName?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  title="Last Name"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.lastName}
                  {...register("lastName")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.lastName?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Phone Number"
                  title="Phone Number"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.phone}
                  {...register("phone")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.phone?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  title="Email"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.email}
                  {...register("email")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.email?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            {/* <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Street Address"
                  title="Street Address"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.address}
                  {...register("address")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.address?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col> */}
            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="City"
                  title="City"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.city}
                  {...register("city")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.city?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="State"
                  title="State"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.state}
                  {...register("state")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.state?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Postal Code"
                  title="Postal Code"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.zip}
                  {...register("zip")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.zip?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Country"
                  title="Country"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.country}
                  {...register("country")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.country?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
